'use client';
import { Button } from '@components';
import styles from './page.module.scss';
import useBrand from '@/hooks/useBrand';
import useNavigate from '@/hooks/useNavigate';

export default function Page() {
  const brand = useBrand();
  const navigate = useNavigate();

  return (
    <div className={styles['content']}>
      <p>Vous avez été déconnecté</p>
      <Button loading={false} onClick={() => navigate('login')}>
        Se connecter
      </Button>
    </div>
  );
}
